export const formatDateTime = (date: number | string, isEndOfDay?: boolean) => {
  if (typeof date === 'string') return date;
  if (!date) return '';

  const dateFormat = new Date(Number(date));

  if (isNaN(dateFormat.getTime())) {
    return '';
  }

  if (isEndOfDay) {
    !dateFormat.getHours() && dateFormat.setHours(23, 59, 59, 999);
  } else {
    !dateFormat.getHours() && dateFormat.setHours(0, 0, 0, 0);
  }

  const isoString = dateFormat?.toISOString();

  return isoString;
};

export const normalizedPhoneNumber = (phoneNumber: string) => {
  return phoneNumber.replace(/\+84/, '0');
};
